export enum ProductEnhancementPreset {
  STUDIO = 'studio',
  LIFESTYLE = 'lifestyle',
  LUXURY = 'luxury',
  MINIMAL = 'minimal',
  OUTDOOR = 'outdoor',
  SOCIAL = 'social',
  COZY_HOME = 'cozy_home',
  COZY_DINNER = 'cozy_dinner',
  COZY_FIREPLACE = 'cozy_fireplace',
}

export const productEnhancementPresetNameMap: Record<
  ProductEnhancementPreset,
  string
> = {
  [ProductEnhancementPreset.STUDIO]: 'Stüdyo Beyaz Arka Plan',
  [ProductEnhancementPreset.LIFESTYLE]: 'Günlük Yaşam Sahnesi',
  [ProductEnhancementPreset.LUXURY]: 'Lüks Koyu Arka Plan',
  [ProductEnhancementPreset.MINIMAL]: 'Minimalist Degrade',
  [ProductEnhancementPreset.OUTDOOR]: 'Açık Hava Görünümü',
  [ProductEnhancementPreset.SOCIAL]: 'Sosyal Medya Uyumlu',
  [ProductEnhancementPreset.COZY_HOME]: 'Sıcak Ev Ortamı',
  [ProductEnhancementPreset.COZY_DINNER]: 'Samimi Akşam Yemeği Masası',
  [ProductEnhancementPreset.COZY_FIREPLACE]: 'Şömine Yanında',
};
